import React from 'react';
import { TRANSFORMERS } from '@lexical/markdown';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import {
  Props as BaseLexicalPropsType,
  ContentEditable,
} from '@lexical/react/LexicalContentEditable';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary';
import { MarkdownShortcutPlugin } from '@lexical/react/LexicalMarkdownShortcutPlugin';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';

import { OpenLinkPlugin } from './plugins/OpenLink';
import { SHARED_LEXICAL_CONFIG } from './SharedLexicalConfig';

export type BaseLexicalProps = {
  config?: Partial<Parameters<typeof LexicalComposer>['0']['initialConfig']>;
  placeholder?: string;
  editable?: boolean;
  children?: React.ReactNode;
  //lexicalcontenteditable
  contentEditableProps?: BaseLexicalPropsType & React.HtmlHTMLAttributes<HTMLDivElement>;
};

export function BaseLexicalComponent({
  config,
  placeholder,
  editable = true,
  children,
  contentEditableProps,
}: BaseLexicalProps) {
  return (
    <LexicalComposer
      initialConfig={{
        ...SHARED_LEXICAL_CONFIG,
        ...config,
        editable,
      }}
    >
      <RichTextPlugin
        contentEditable={<ContentEditable spellCheck={false} {...contentEditableProps} />}
        placeholder={<Placeholder placeholder={placeholder} />}
        ErrorBoundary={LexicalErrorBoundary}
      />
      <MarkdownShortcutPlugin transformers={TRANSFORMERS} />
      <OpenLinkPlugin />
      {children}
    </LexicalComposer>
  );
}

const Placeholder = ({ placeholder = '' }: { placeholder?: string }) => {
  return <div className="pointer-events-none absolute left-4 top-4 opacity-50">{placeholder}</div>;
};
